import joi from 'joi';

// eslint-disable-next-line import/prefer-default-export
export const email = joi
    .string()
    .email({ tlds: { allow: false } })
    .required()
    .messages({
        'string.empty': 'Email is required',
        'string.email': 'Email is invalid',
    });

export const password = joi.string().required().messages({
    'string.empty': 'Password is required',
});

export const repeatNewPassword = joi.string().required().messages({
    'string.empty': 'Repeat password is required',
});
